"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateHighlightSearchPatternDto = instanceOfUpdateHighlightSearchPatternDto;
exports.UpdateHighlightSearchPatternDtoFromJSON = UpdateHighlightSearchPatternDtoFromJSON;
exports.UpdateHighlightSearchPatternDtoFromJSONTyped = UpdateHighlightSearchPatternDtoFromJSONTyped;
exports.UpdateHighlightSearchPatternDtoToJSON = UpdateHighlightSearchPatternDtoToJSON;
exports.UpdateHighlightSearchPatternDtoToJSONTyped = UpdateHighlightSearchPatternDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateHighlightSearchPatternDto interface.
 */
function instanceOfUpdateHighlightSearchPatternDto(value) {
    return true;
}
function UpdateHighlightSearchPatternDtoFromJSON(json) {
    return UpdateHighlightSearchPatternDtoFromJSONTyped(json, false);
}
function UpdateHighlightSearchPatternDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'pattern_template': json['pattern_template'] == null ? undefined : json['pattern_template'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
    };
}
function UpdateHighlightSearchPatternDtoToJSON(json) {
    return UpdateHighlightSearchPatternDtoToJSONTyped(json, false);
}
function UpdateHighlightSearchPatternDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'pattern_template': value['pattern_template'],
        'is_active': value['is_active'],
    };
}
